import PackLearnProgress from "./packLearnProgress.es6";

export default class PackReviewProgress extends PackLearnProgress {
    constructor(view, json) {
        super(view, json)
    }

    getStatus(card) {
        const correctAnswers = this.getCorrect('select', card) + this.getCorrect('write', card);
        if (correctAnswers >= 2) {
            return 'mastered';
        } else if (correctAnswers >= 1) {
            return 'familiar';
        } else {
            return 'remaining';
        }
    }
}